import React from 'react';
import { Fragment } from 'react';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Header from '../../../components/headerrh';
import Funcionarios from '../../../components/rh/funcionarios/listar/senha';


function EditFuncionariosSenhaScreen () {
    return (
        <Fragment>
            <Head titulo="Edição de Senha dos Funcionarios | Consórcio LVF" />
            <Header />
            <Funcionarios />
            <Footer />
        </Fragment>
    );
}

export default EditFuncionariosSenhaScreen;